import { Link } from 'react-router-dom';
import { useAuth } from '../../contextos/AuthContext'; // Importa o hook useAuth do contexto de autenticação para acessar o estado do usuário logado e funções relacionadas à autenticação



/*  Componente de página para Painel de Controle
    Neste elemento podemos colocar funcionalidades administrativas, como listagem de usuários, controle de acesso, etc.
    Este elemento é referenciado na configuração de rotas em src/routes.js 
    Este componente encapsula o componente CadastroUsuario que contém o formulário real de cadastro 
*/
const PainelControle = () => {
    const usuarioLogado = useAuth().dadosUsuario; // Hook para acessar o contexto de autenticação e obter os dados do usuário logado
    const tipo = usuarioLogado?.tipo; // Acessa o tipo do usuário logado, se disponível
    console.log("Tipo de usuário no Painel de Controle:", tipo); // Log para verificar o tipo do usuário
    return (

        /// Estrutura básica do painel de controle, com links para funcionalidades administrativas. Conforme o tipo de usuário, podemos mostrar ou ocultar certos links ou funcionalidades. Por exemplo, apenas administradores podem ver a listagem de usuários e opções de controle de acesso.

        
        // 'container-lg' centraliza o conteúdo e adiciona margens laterais automáticas
        // 'py-5' adiciona margem superior e inferior para o título não colar no topo
        <div className="container-lg py-5">
            
            <h1 className="h1 mb-4">Painel de Controle</h1>

            {/* Usamos 'row' para o grid. 
                'row-cols-1': 1 card por linha no celular.
                'row-cols-md-2': 2 cards por linha em tablets.
                'row-cols-lg-4': EXATAMENTE 4 cards por linha em desktop.
                'g-4': Espaçamento (gutter) entre os cards.
            */}
            
            <div className="row row-cols-1 row-cols-md-2 row-cols-lg-4 g-4 justify-content-center">

            { usuarioLogado && (
                <>
                <div className="col">
                    <div className="card fs-5">
                        <div className="p-5 card-body text-center">
                            <Link 
                            className='fs-2 link-opacity-50 link-underline-success link-underline-opacity-25 link-underline-opacity-50-hover'
                            to="/cadastro-usuario" 
                            // Passa os dados do usuário logado para o componente de cadastro
                            state={{ usuario: usuarioLogado }}> 
                                Meus Dados
                            </Link>
                        </div>
                    </div>
                </div> 

                <div className="col">
                    <div className="card fs-5">
                        <div className="p-5 card-body text-center">
                            <Link 
                            className='fs-2 link-opacity-50 link-underline-success link-underline-opacity-25 link-underline-opacity-50-hover'
                            to="/listagem-forum-minhas-mensagens" > 
                                Minhas Mensagens do Fórum
                            </Link>
                        </div>
                    </div>
                </div> 
                </>
                
            )
            }

            {/* 1. VISÃO DO ADMINISTRADOR*/}
            { tipo === 'admin' && ( 
                <div className="col">
                    <div className="card fs-5 ">
                        <div className="p-5 card-body text-center">
                            <Link 
                                className='fs-2 link-opacity-50 link-underline-success link-underline-opacity-25 link-underline-opacity-50-hover'
                                to="/listagem-usuarios"
                            >
                                Listagem de Usuários
                            </Link>
                        </div>
                    </div>
                </div>
                ) 
            }

            {/* 2. VISÃO DO ADMINISTRADOR E EDITOR */}
            {  (tipo === 'admin' || tipo === 'editor') &&  ( 
                <>
                <div className="col">
                    <div className="card fs-5 ">
                        <div className="p-5 card-body text-center">
                            <Link 
                                className='fs-2 link-opacity-50 link-underline-success link-underline-opacity-25 link-underline-opacity-50-hover'
                                to="/cadastro-artigo"
                                // Passa os dados do usuário logado para o componente de cadastro
                                state={{ usuario: usuarioLogado }}
                            >
                                Novo artigo
                            </Link>
                        </div>
                    </div>
                </div>   


                <div className="col">
                    <div className="card fs-5 ">
                        <div className="p-5 card-body text-center">
                            <Link 
                                className='fs-2 link-opacity-50 link-underline-success link-underline-opacity-25 link-underline-opacity-50-hover'
                                to="/listagem-artigos"
                                state={{ status: "" }} // Neste ponto da aplicação, o status de filtro é passado como string vazia, o que significa que a listagem de artigos irá buscar todos os artigos, independentemente do status. O componente de listagem de artigos pode então usar esse valor para determinar quais artigos exibir, ou seja, se deve exibir apenas os artigos publicados, ou todos os artigos, incluindo rascunhos e pendentes.
                            >
                                Listar todos os Artigos
                            </Link>
                        </div>
                    </div>
                </div>


                <div className="col">
                    <div className="card fs-5 ">
                        <div className="p-5 card-body text-center">
                            <Link 
                                className='fs-2 link-opacity-50 link-underline-success link-underline-opacity-25 link-underline-opacity-50-hover'
                                to="/listagem-artigos"
                                state={{ status: "enviado" }} // Neste ponto da aplicação, o status de filtro é passado como string enviado para indicar que a listagem de artigos deve buscar apenas os artigos que estão com status "enviado", ou seja, aqueles que foram enviados para revisão, mas ainda não foram publicados. O componente de listagem de artigos pode então usar esse valor para filtrar os artigos exibidos, mostrando apenas aqueles que estão aguardando revisão ou aprovação.
                            >
                                Artigos a publicar
                            </Link>
                        </div>
                    </div>
                </div>

                <div className="col">
                    <div className="card fs-5 ">
                        <div className="p-5 card-body text-center">
                            <Link 
                                className='fs-2 link-opacity-50 link-underline-success link-underline-opacity-25 link-underline-opacity-50-hover'
                                to="/listagem-forum-moderacao"
                                state={{status:'enviado'}}
                            >
                                Comentários a publicar
                            </Link>
                        </div>
                    </div>
                </div>

                <div className="col">
                    <div className="card fs-5 ">
                        <div className="p-5 card-body text-center">
                            <Link 
                                className='fs-2 link-opacity-50 link-underline-success link-underline-opacity-25 link-underline-opacity-50-hover'
                                to="/listagem-forum-moderacao"
                                state={{status: "bloqueado"}}
                                
                            >
                                Lista Fórum - Mensagens Bloqueadas
                            </Link>
                        </div>
                    </div>
                </div>
                </>
                ) 
            }
                
            {/* 3. MENSAGEM PARA QUEM NÃO TEM PERMISSÃO (LEITOR OU DESLOGADO) */}
            { (!usuarioLogado || !tipo) &&   (
                        <p className="fs-5">Acesso negado. Por favor, faça login para acessar o seu perfil.</p>
                )
            }

            {/* Adicione mais links para outras funcionalidades administrativas conforme necessário */}

            </div>

            {/* Aqui você pode adicionar funcionalidades administrativas, como listagem de usuários, controle de acesso, etc. */}   


        </div>

        

    )
}

export default PainelControle
  